import { useSelector } from 'react-redux'

import ContentFrame from 'components/Frame/ContentFrame'
import TerraBackfill from 'components/Terra/TerraBackfill'
import WearablesStats from 'components/Athlete/WearablesStats'

export default function WearablesTab() {

    const terraUserId = useSelector(state => state.athleteProfile.terraUserId)
    const type = useSelector(state => state.user.type)
    const athleteId = useSelector(state => state.athleteProfile.userId)

    if (terraUserId === '') {
        return (
            <ContentFrame>
                <div className="text-center text-gray-500 py-4">No wearable device connected. Athletes can connect a wearable device on the athlete app</div>
            </ContentFrame>
        )
    }

    return (
        <>
            {type === 'super-admin' && <TerraBackfill userId={athleteId} />}

            <WearablesStats userId={athleteId} />
        </>
    )
}